import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IndustryLeader001 from '../../../../assets/IndustryLeader001.png';
import IndustryLeader002 from '../../../../assets/IndustryLeader002.png';
import IndustryLeader003 from '../../../../assets/IndustryLeader003.png';
import IndustryLeader004 from '../../../../assets/IndustryLeader004.png';
import IndustryLeader005 from '../../../../assets/IndustryLeader005.png';
import IndustryLeader006 from '../../../../assets/IndustryLeader006.png';
import IndustryLeader007 from '../../../../assets/IndustryLeader007.png';
import IndustryLeader008 from '../../../../assets/IndustryLeader008.png';
import {
  BACKGROUND_BLACK,
  ORANGE,
} from '../../../../styles/Colors';
import { mobileDevice } from '../../../../constants/DeviceBreakPoints';
import {
  Mobile,
  Default,
} from '../../../../components/MediaQueryComponent';

const styles = theme => ({
  screenContainer: {
    backgroundColor: BACKGROUND_BLACK,
    padding: '10px 20px',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mainText: {
    fontSize: 30,
    textAlign: 'center',
    fontFamily: 'Poppins, sans-serif',
    color: ORANGE,
    fontWeight: 'bold',
    lineHeight: 1.2,
    padding: '8px 0',
    margin: 30,
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 18,
      margin: 10,
    },
  },
  imageRowContainer: {
    width: '80%',
    maxWidth: 1100,
    display: 'flex',
    justifyContent: 'space-around',
  },
  imageStyle: {
    width: 120,
    objectFit: 'contain',
    margin: 8,
    minHeight: 70,
  },
});

const imageRow1 = [
  IndustryLeader001,
  IndustryLeader002,
  IndustryLeader003,
  IndustryLeader004,
];
const imageRow2 = [
  IndustryLeader005,
  IndustryLeader006,
  IndustryLeader007,
  IndustryLeader008,
];

const IndustryLeaderSection = ({
  classes,
}) => {
  const renderImage = imageSource => (
    <img
      key={imageSource}
      alt={imageSource}
      src={imageSource}
      className={classes.imageStyle}
    />
  );

  return (
    <div className={classes.screenContainer}>
      <div className={classes.mainText}>
        Utilizied On Projects by Industry Leaders
      </div>
      <Mobile>
        {imageRow1.map(content => renderImage(content))}
        {imageRow2.map(content => renderImage(content))}
      </Mobile>
      <Default>
        <div className={classes.imageRowContainer}>
          {imageRow1.map(content => renderImage(content))}
        </div>
        <div className={classes.imageRowContainer}>
          {imageRow2.map(content => renderImage(content))}
        </div>
      </Default>
    </div>
  );
};

IndustryLeaderSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IndustryLeaderSection);
